export default __webpack_public_path__ + "static/media/ck.6211453f.svg";